import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './HILT.module.css';
import { getPropByName } from '../../../../utils/props';

const TASK_REMARK_TYPE = 'task_HILT_intake_shortlease';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
    
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 6px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HILT_intake_shortleaseComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.setState({
      HILT_repair_remark: getPropByName(this.props.vehicle, 'HILT_repair_remark'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle != this.props.vehicle) {
      this.setState({
        HILT_repair_remark: getPropByName(this.props.vehicle, 'HILT_repair_remark'),
      });
    }
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return [
      'task_HILT_Complete_files',
      'task_HILT_Charge_own_risks',
      ...(this.vehicle.workflow_id != 1 ? ['task_HILT_Book_depreciation'] : []),
      'task_HILT_Send_report_to_customer_PDF',
    ];

    return props;
  }

   

  get doubleCheckPropsExtra() {
    let props = ['task_HILT_shortages_mandatory', 'task_HILT_repair_order' ];

    return props;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = false;

    this.doubleCheckProps.forEach(prop => {
      if (this.props.vehicle?.[prop] !== '0') {
        disable = true;
      }
    });

    return disable;
  }

    renderEditableVehicleFields() {
      return (
        <VBox>
          {['HILT_repair_remark'].map(prop => {
            return (
              <HBox key={prop} vCenter gap={'8px'}>
                {/* <HBox> */}
                {this.lbl(`vehicle.property.${prop}`)}
                <VehiclePropertyLoadable name={prop}>
                  <div className={styles.buttonLabel}>
                    <div className={styles.labelCompany}>
                      <input
                        className="form-control"
                        type={prop}
                        value={this.state[prop]}
                        onChange={this.onInputChange.bind(this)}
                        name={prop}
                        key={prop}
                        onBlur={() => {
                          this.state[prop] && this.props.setProperty(prop, this.state[prop]);
                          console.log('onBlur', this.state[prop]);
                        }}
                      />
                    </div>
                  </div>
                </VehiclePropertyLoadable>
                {/* </HBox> */}
              </HBox>
            );
          })}
        </VBox>
      );
    }

  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = val === undefined || val === 0 ? null : val == 1 ? 1 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className={`btn btn-outline-primary ${state == 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                {name == 'task_HILT_repair_order' || name == 'task_HILT_shortages_mandatory' ? ('Ja'):('Todo')}
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className={`btn btn-outline-primary ${state == 0 ? 'active' : ''}`} htmlFor={`btnradio2-${name}`}>
              {name == 'task_HILT_repair_order' || name == 'task_HILT_shortages_mandatory' ? ('Nee'):('Gereed')}
              </label>
            </div>
            {/*<div className="check">{state == 0 ? '-' : '+'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  get tripleCheckProps() {
    let props = ['task_HILT_Request_shortages'];

    return props;
  }

  renderTripleCheck(name) {
      let val = this.propertyValue(name);
      let state = val == 1 ? 1 : val == 2 ? 2 : 0;
  
      return (

          <div
            className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
            // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
          >
            <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
            <VehiclePropertyLoadable name={name}>
              <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`} // uniek per veld
                  id={`btnradio1-${name}`}
                  autoComplete="off"
                  checked={state == 0}
                  onChange={() => this.props.setProperty(name, 0)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>Todo</label>
  
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio2-${name}`}
                  autoComplete="off"
                  checked={state == 1}
                  onChange={() => this.props.setProperty(name, 1)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>Niet van toepassing</label>
  
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio3-${name}`}
                  autoComplete="off"
                  checked={state == 2}
                  onChange={() => this.props.setProperty(name, 2)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>Opgevraagd</label>
              </div>
            </VehiclePropertyLoadable>
          </div>
      
      );
    }

 

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>{this.doubleCheckProps.map(name => this.renderDoubleCheck(name))}</Cell>
              </Row>
              <Row>
                <Cell>
                  {this.tripleCheckProps.map(name => this.renderTripleCheck(name))}
                </Cell>
              </Row> <Row>
                <Cell>
                  {(this.vehicle.workflow_id == '1' || this.vehicle.workflow_id == '10') &&
                    this.doubleCheckPropsExtra.map(name => this.renderDoubleCheck(name))}
                </Cell>
                </Row>
                <Row>
                <Cell>
                {(this.vehicle.workflow_id == '1' || this.vehicle.workflow_id == '10') && this.renderEditableVehicleFields()}
                </Cell>
              </Row>
            </VBox>
         
            
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HILT_intake_shortleaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HILT_intake_shortlease = compose(withConnect, withRouter)(HILT_intake_shortleaseComp);
